import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';

import { AdminCrmRoutes } from './subapps/crm/routes';
import { AdminIamRoutes } from './subapps/iam/routes';
import { AdminSalesRoutes } from './subapps/sales/routes';
import { AdminSuiteRoutes } from './subapps/suite/routes';
import { AdminTalkRoutes } from './subapps/talk/routes';
import Welcome from './welcome.vue';

export const AdminRoutes: RouteRecordRaw[] = [
    {
        path: '',
        component: Welcome,
        meta: { admin: true }
    },
    {
        path: 'iam',
        component: wrapRuntimeImport(() => import('./subapps/iam/iam.vue')),
        meta: { admin: true },
        children: AdminIamRoutes
    },
    {
        path: 'suite',
        component: wrapRuntimeImport(() => import('./subapps/suite/suite.vue')),
        meta: { admin: true },
        children: AdminSuiteRoutes
    },
    {
        path: 'crm',
        component: wrapRuntimeImport(() => import('./subapps/crm/crm.vue')),
        meta: { admin: true },
        children: AdminCrmRoutes
    },
    {
        path: 'sales',
        component: wrapRuntimeImport(() => import('./subapps/sales/sales.vue')),
        meta: { admin: true },
        children: AdminSalesRoutes
    },
    {
        path: 'talk',
        component: wrapRuntimeImport(() => import('./subapps/talk/talk.vue')),
        meta: { admin: true },
        children: AdminTalkRoutes
    }
];
